<template>
  <div class="image-div" :style="{ 'background-image': 'url(' + url + ')' }"></div>
</template>

<script>
import firebase from 'firebase'

export default {
  props: [ 'imagePath', 'thumbSize' ],
  data () {
    return {
      url: null,
      loading: true,
      error: null
    }
  },
  mounted () {
    let imagePath = this.imagePath.replace('images/', '')
    let storage = firebase.storage().ref()
    let imageRef = storage.child('thumbs/' + imagePath + '_' + this.thumbSize + '_thumb.jpg')
    imageRef.getDownloadURL()
      .then(
        (url) => {
          this.loading = false
          this.url = url
        },
        (error) => {
          switch (error.code) {
            case 'storage/object_not_found':
              console.log('File doesn\'t exist')
              break
            case 'storage/unauthorized':
              console.log('User doesn\'t have permission to access the object')
              break
            case 'storage/canceled':
              console.log('User canceled the upload')
              break
            case 'storage/unknown':
              console.log('Unknown error occurred, inspect the server response')
              break
          }
          this.loading = false
          this.error = error
        }
      )
  }
}
</script>

<style lang="scss" scoped>
  .image-div {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/MediaImage.vue